import '../assets/css/header.css'

import {
  User,
  Down_1,
  MiniExit,
  MiniOrders,
  MiniUser,
  MiniWallet,
  Iconbk_user_btn_header
} from '../../assets/icones/icones';
import React, {Fragment,useEffect, useRef, useState } from 'react';
import {Link, NavLink} from 'react-router-dom';

import clientconfigwebapp, {
  check_login_appbk,
  modal_login_reg_bk_show,
  FormatNumberByhkh,
  modal_select_agent_show_hide,
  modal_cart_show_hide, Token_get_appbk,
} from '../../clientconfigwebapp';

import Grid from '@mui/material/Grid';



import logo_web_app from '../../assets/images/logo.png';



import axios from "axios";
import {toast} from "react-toastify";
import Menu_Mobile_Front_Pages from "../Menu_Mobile_Front_Pages"
import Category_Selector_Menu from "../CategorySelector/Category_Selector_Menu"
import Modal from "@mui/material/Modal";
import Grow from "@mui/material/Grow";
import Box from "@mui/material/Box";
const Header = (props) => {
  const dropDown = useRef(null);
  const svg = useRef(null);
  const [theme , setTheme] = useState();

  const [data_category_box, set_data_category_box] = useState([]);

  ///const [open, setOpen_modal_filter] = React.useState(false);
  const [open, setOpen_modal_filter] = useState(false);

  const handle_modal_filter_Open = () => setOpen_modal_filter(true);
  const handle_modal_filter_Close = () => setOpen_modal_filter(false);






  const style = {
    position: 'absolute',
    top: '20%',
    left: '35%',
    transform: 'translate(-35%, -35%)',
    width: "35%",
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: "10px",
  };


  const [scrolled, setScrolled] = useState(false);



  useEffect(() => {

    setTheme('light');

  });

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    Load_api_page();
  }, [1]);


  const Load_api_page= () => {

    var config = null;


    axios.post(`${clientconfigwebapp.siteurl}api/v1/home-get-data/` ,null,config)
        .then((res) => {


          if(String(res.data).length > 0) {

            if(String(res.data.data_category_box).length > 0) {  set_data_category_box(res.data.data_category_box); }


          }else{
            if(String(res.data.msgwebapp).length > 0)  toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
          }

        }).catch((err) =>{
      toast.error('خطا اتصال به سرور کد  5156', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
    });


  }



  const  menuHandler = () => {
    const menu = document.querySelector('.home-aside-container')
    menu.classList.toggle('mob-menu-act')
  }
  const dropDownHandler = () => {
    dropDown.current.classList.toggle('active');
    console.log(svg.current);
    svg.current.classList.toggle('svg-active');

  }

  const themeHandler = () => {
    if(document.body.classList.contains('body')) {
      document.body.classList.remove('body');
      document.body.classList.add('dark');
      localStorage.setItem("themes_status","dark");

    } else {
      document.body.classList.remove('dark');
      document.body.classList.add('body');
      localStorage.setItem("themes_status","white");
    }


  }

  const Handler_login_show_bk = () => {
    modal_login_reg_bk_show("login_reg_check_view_modal");
  };

  const Handler_select_agent_show_bk = () => {
    modal_select_agent_show_hide("show");
  };

  const Handler_card_mobile_show_bk = () => {
    modal_cart_show_hide("show");
  };

  const Handler_card_mobile_hide_bk = () => {
    modal_cart_show_hide("hide");
  };

  const data_item_menu = [
    {
      path: '/panel/dashboard',
      title: 'پنل کاربری',
      icon: <MiniUser color={'var(--c7)'} />
    },
    {
      path: '/login',
      title: 'خروج',
      icon: <MiniExit color={'var(--c7)'} />
    },
  ]



  return (
      <Fragment>


        <div id={"headerbk"} className={`flexRowBetCenter w-100 header-container_bk ${props.backgroundtr}  ${scrolled ? 'header-scrolled-bk' : ''}`}>


          <div className={"menu-header-right-pc"}>
            <button className={"btn-menu-cat-header"} type={"button"} onClick={handle_modal_filter_Open}>
              <svg width={18} height={19} viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_2277_5582)">
                  <path
                      d="M15 13.625C15.2889 13.6251 15.5667 13.7364 15.7758 13.9358C15.9849 14.1352 16.1093 14.4074 16.1231 14.6959C16.137 14.9845 16.0394 15.2674 15.8504 15.4859C15.6614 15.7044 15.3956 15.8419 15.108 15.8698L15 15.875H3C2.71109 15.8749 2.4333 15.7636 2.22421 15.5642C2.01512 15.3648 1.89074 15.0926 1.87686 14.8041C1.86297 14.5155 1.96064 14.2326 2.14963 14.0141C2.33862 13.7956 2.60444 13.6581 2.892 13.6302L3 13.625H15ZM15 8.375C15.2984 8.375 15.5845 8.49353 15.7955 8.7045C16.0065 8.91548 16.125 9.20163 16.125 9.5C16.125 9.79837 16.0065 10.0845 15.7955 10.2955C15.5845 10.5065 15.2984 10.625 15 10.625H3C2.70163 10.625 2.41548 10.5065 2.2045 10.2955C1.99353 10.0845 1.875 9.79837 1.875 9.5C1.875 9.20163 1.99353 8.91548 2.2045 8.7045C2.41548 8.49353 2.70163 8.375 3 8.375H15ZM15 3.125C15.2984 3.125 15.5845 3.24353 15.7955 3.4545C16.0065 3.66548 16.125 3.95163 16.125 4.25C16.125 4.54837 16.0065 4.83452 15.7955 5.0455C15.5845 5.25647 15.2984 5.375 15 5.375H3C2.70163 5.375 2.41548 5.25647 2.2045 5.0455C1.99353 4.83452 1.875 4.54837 1.875 4.25C1.875 3.95163 1.99353 3.66548 2.2045 3.4545C2.41548 3.24353 2.70163 3.125 3 3.125H15Z"
                      fill="#ffff"/>
                </g>
                <defs>
                  <clipPath id="clip0_2277_5582">
                    <rect width={18} height={18} fill="white" transform="translate(0 0.5)"/>
                  </clipPath>
                </defs>
              </svg>
              <span className={"title-btn-menu-cat-header"}>همه دسته بندی ها</span>
            </button>

            <a className={"link-menu-header-pc"} target={"_blank"} href={"https://bazaarano.com/blog/"}>مقالات</a>
            <a className={"link-menu-header-pc"} href={String(clientconfigwebapp.webappurl) + "about-us"}>درباره ما</a>
            <a className={"link-menu-header-pc"} href={String(clientconfigwebapp.webappurl) + "contact-us" }>تماس با ما</a>

          </div>

          {/*<button className='menu-btn' onClick={menuHandler}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="50px" height="50px"><path d="M 5 8 A 2.0002 2.0002 0 1 0 5 12 L 45 12 A 2.0002 2.0002 0 1 0 45 8 L 5 8 z M 5 23 A 2.0002 2.0002 0 1 0 5 27 L 45 27 A 2.0002 2.0002 0 1 0 45 23 L 5 23 z M 5 38 A 2.0002 2.0002 0 1 0 5 42 L 45 42 A 2.0002 2.0002 0 1 0 45 38 L 5 38 z"/></svg></button>*/}

          <div className="header__logo">
            <Link className={"hover-text-appbk"} to={"/"}><img src={logo_web_app}/></Link>
          </div>


          <div className="box-left-btn-header">


            {

              check_login_appbk() === false ?

                  <NavLink reloadDocument={true}  to={"/login-register"} className='flexRowBetCenter btn-login-header'>
                    <Iconbk_user_btn_header color={'var(--c7)'}/><span>ورود /  عضویت</span>
                  </NavLink>

                  :
                  <Fragment>

                    <button style={{backgroundColor: "#484848"}}
                            className='flexRowBetCenter btn-login-header btn-logined-pc' onClick={dropDownHandler}>
                      <Iconbk_user_btn_header color={'#fffff'}/>
                      <span>{String(props.first_name_profile) + " " + String(props.last_name_profile)}</span>
                      <span ref={svg}>
                    <Down_1 color={"#ffffff"} className='header-svg'/>
                    </span>
                    </button>



                    <button className='btn-logined-mobile' style={{display: "none"}} onClick={dropDownHandler}>
                      <svg style={{"color": "#9ca3af"}} className="w-8 h-8 text-gray-400 group-hover:text-gray-600"
                           fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                              d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                      </svg>
                    </button>


                    <div className='user-menu-dropdown' ref={dropDown}>

                      <div className={"modal-bg-bk modal-bg-bk-menumob"} onClick={dropDownHandler}></div>

                      <div className="w-100 profile__container">



                        <div className="flexColStartStart w-100 profile__container__body">
                          <ul className='w-100'>
                            {data_item_menu && data_item_menu.map((item, index) => {
                                  return (
                                      <li key={index} className='w-100 link-menu-mini'>
                                        <NavLink
                                            className={({isActive}) => isActive ? 'w-100 flexRowStartCenter pro-active' : 'w-100 flexRowStartCenter'}
                                            to={`${item.path}`}>
                                          {item.icon}
                                          <span>{item.title}</span>
                                        </NavLink>
                                      </li>
                                  )
                                }
                            )}
                          </ul>
                        </div>
                      </div>


                    </div>

                  </Fragment>
            }


          </div>
        </div>


        <Modal
            id={"modal_filter"}
            open={open}
            onClose={handle_modal_filter_Close}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            disableScrollLock={false}
            keepMounted={true}
            hideBackdrop={false}
            disablePortal={true}  ////render current dom
            className={"modal_muibk"}
        >

          <Grow style={{transformOrigin: '0 0 0'}} {...(open ? {timeout: 1000} : {})} in={open}>
            <Box sx={style}>
                                    <span onClick={handle_modal_filter_Close} style={{
                                      "color": "#9b9b9b",
                                      "position": "relative",
                                      "left": "0px",
                                      "top": "0px",
                                      "fontSize": "23px",
                                      "cursor": "pointer"
                                    }}>X</span>



              <div><Category_Selector_Menu categories={data_category_box}/></div>



            </Box>

          </Grow>
        </Modal>


        {/*<div><Menu_Mobile_Front_Pages data_category_box={data_category_box}/></div>*/}

      </Fragment>
  )
}
export default Header;